import { ref, computed } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import Skeleton from '../../../components/skeleton/component-lib.esm.js';
import RatioBox from '../../../components/ratio-box/component-lib.esm.js';

//
var script = {
  components: {
    Skeleton,
    RatioBox
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const root = ref(null);
    const rootEl = computed(() => {
      var _root$value;
      return (_root$value = root.value) === null || _root$value === void 0 ? void 0 : _root$value.$el;
    });
    useIntersectionObserver(rootEl, _ref2 => {
      let [{
        isIntersecting
      }] = _ref2;
      if (isIntersecting) {
        emit('is-in-view');
      }
    });
    return {
      root
    };
  }
};
export { script as default };